import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'

const state = {
  token: '1',
  name: '',
  avatar: '',
  lognavtxt:"",
  roles: [],
  lognavtxt:"%E5%85%84%E5%BC%9F%E8%BF%99%E5%AE%B6%E5%85%AC%E5%8F%B8boss%E5%B7%A8%E5%9D%91%EF%BC%8C%E6%88%91%E5%B7%B2%E7%BB%8F%E8%BE%9E%E8%81%8C%E4%BA%86%EF%BC%8C%E5%85%AC%E5%8F%B8boss%E5%98%B4%E4%B8%8A%E8%AF",
  
}

const mutations = {
  modifylt(status,value){
    status.lognavtxt = value
  }
}

const actions = {
  login({ commit }, userInfo) {
    console.log('login');
  },

  // get user info
  getInfo({ commit, state }) {

  },

  // user logout
  logout({ commit, state, dispatch }) {

  },

  // remove token
  resetToken({ commit }) {

  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}